import { KeyboardKeys, KEYBOARD_KEY_CODES, ValueOf } from '../constants/keyboard';

export type KeyboardKeysType = ValueOf<typeof KeyboardKeys>;

export function isKeyboardKeyCode(code: string): code is KeyboardKeysType {
    return KEYBOARD_KEY_CODES.includes(<KeyboardKeysType>code);
}
